import { useState, type FormEvent } from 'react'
import { Link, useSearchParams } from 'react-router'
import { LoopApiError } from '@innerloopco/loopcms-core'
import { Button, Field, Input } from '../../components/index.js'
import { api } from '../../lib/api.js'
import { PASSWORD_TOO_SHORT, PASSWORDS_DIFFER, SignedOutLayout } from './SignedOutLayout.js'

export function ResetPassword() {
  const [params] = useSearchParams()
  const token = params.get('token') ?? ''
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [dead, setDead] = useState(false)
  const [done, setDone] = useState(false)
  const [busy, setBusy] = useState(false)

  const onSubmit = (event: FormEvent) => {
    event.preventDefault()
    if (password.length < 8) {
      setError(PASSWORD_TOO_SHORT)
      return
    }
    if (password !== confirm) {
      setError(PASSWORDS_DIFFER)
      return
    }
    setBusy(true)
    setError(null)
    api
      .resetPassword(token, password)
      .then(() => setDone(true))
      .catch((caught: unknown) => {
        if (caught instanceof LoopApiError && caught.code === 'invalid_token') {
          setDead(true)
          setError('That reset link has expired or was already used.')
        } else {
          setError(caught instanceof LoopApiError ? caught.message : 'Something went wrong. Try again.')
        }
      })
      .finally(() => setBusy(false))
  }

  if (done) {
    return (
      <SignedOutLayout title="Reset your password">
        <p role="status" style={{ margin: 0, fontSize: 13 }}>Password updated. Sign in with it.</p>
        <Link to="/" style={{ fontSize: 13 }}>Go to sign in</Link>
      </SignedOutLayout>
    )
  }

  return (
    <SignedOutLayout title="Reset your password">
      <form className="stack" style={{ gap: 'var(--space-4)' }} onSubmit={onSubmit}>
        <Field label="New password" help={PASSWORD_TOO_SHORT}>
          <Input type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="new-password" autoFocus />
        </Field>
        <Field label="Confirm password" error={error ?? undefined}>
          <Input type="password" value={confirm} onChange={(event) => setConfirm(event.target.value)} autoComplete="new-password" />
        </Field>
        <Button type="submit" variant="primary" block disabled={busy || dead} style={{ minHeight: 42 }}>
          {busy ? 'Saving…' : 'Set new password'}
        </Button>
        {dead ? <Link to="/" style={{ fontSize: 13 }}>Request a new one</Link> : null}
      </form>
    </SignedOutLayout>
  )
}
